import React from 'react'
import { DownloadIcon } from '../../../../icons/Icons'

export const Attachment = props => (
  <a
    className="quick_reply attachment"
    href={props.url}
    download={props.title}
    target="_blank"
    rel="noreferrer">
    <span>
      <DownloadIcon /> {props.title}
    </span>
  </a>
)
